var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect } from "react";
import Select from "react-select";
import "@frameworks/shared-library/stylesheets/components/GenericSelect/GenericSelect.scss";
function GenericSelect(props) {
    var _a = props.showSelectOptionByDefault, showSelectOptionByDefault = _a === void 0 ? true : _a;
    var _b = __read(React.useState([]), 2), options = _b[0], setOptions = _b[1];
    function handleBlur(e) {
        (props === null || props === void 0 ? void 0 : props.onBlur) &&
            props.onBlur(e, { target: props === null || props === void 0 ? void 0 : props.value, required: props === null || props === void 0 ? void 0 : props.required });
        // if ((props?.required && !props?.value) || props?.errorText) {
        //   setErrorText(
        //     props?.errorText ? props?.errorText : "This field is Required"
        //   );
        // } else {
        //   setErrorText("");
        // }
    }
    useEffect(function () {
        var dropdownOptions = [];
        if (props === null || props === void 0 ? void 0 : props.defaultOptions) {
            dropdownOptions.push({ label: props.defaultOptions, value: "" });
        }
        else if (showSelectOptionByDefault) {
            dropdownOptions.push({ label: "Select", value: "" });
        }
        if ((props === null || props === void 0 ? void 0 : props.options) && props.options.length > 0) {
            dropdownOptions.push.apply(dropdownOptions, __spreadArray([], __read(props === null || props === void 0 ? void 0 : props.options), false));
        }
        setOptions(dropdownOptions);
    }, [props.defaultOptions, props.options, showSelectOptionByDefault]);
    return (React.createElement("label", { className: "select-dropdown ".concat((props === null || props === void 0 ? void 0 : props.parentClassName) ? props === null || props === void 0 ? void 0 : props.parentClassName : "", "  ").concat((props === null || props === void 0 ? void 0 : props.errorText) ? "select_error" : "", " ").concat((props === null || props === void 0 ? void 0 : props.backArrowButton) ? "d-flex align-items-center" : "") },
        (props === null || props === void 0 ? void 0 : props.backArrowButton) && (props === null || props === void 0 ? void 0 : props.backArrowButton),
        React.createElement(Select, __assign({}, props, { onBlur: function (e) {
                handleBlur(e);
            }, options: options })),
        (props === null || props === void 0 ? void 0 : props.errorText) && React.createElement("p", { className: "help_text red" }, props === null || props === void 0 ? void 0 : props.errorText)));
}
export default GenericSelect;
